import { render, staticRenderFns } from "./product_area.vue?vue&type=template&id=7b8b1cd4&scoped=true&"
import script from "./product_area.vue?vue&type=script&lang=js&"
export * from "./product_area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8b1cd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b8b1cd4')) {
      api.createRecord('7b8b1cd4', component.options)
    } else {
      api.reload('7b8b1cd4', component.options)
    }
    module.hot.accept("./product_area.vue?vue&type=template&id=7b8b1cd4&scoped=true&", function () {
      api.rerender('7b8b1cd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/available/avail_rule/form/components/product_area.vue"
export default component.exports